import React, { useState } from 'react'
import { Link, useOutletContext } from "react-router-dom";
import df from '../../images/Default_pfp.jpg';
function FriendCardMain({data, type}) {
        const { user, token } = useOutletContext();
        const [status, setStatus] = useState(false);
        const [message, setMessage] = useState("");
        let uid={};

    const sendRequest = () => {
       fetch('/api/send-friend-request', {
           method:'POST',
           headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`
           },
           body: JSON.stringify({friend_id: data.id})
       }).then((response) => response.json())
       .then((data) => {
         
           setStatus(true);
           setMessage("Friend Request Sent");
       }).catch((error) => {
           setMessage("Something went wrong");
       })
    }
    const acceptRequest = () => {
      console.log("accept");
      setStatus(true);
      setMessage("Friend Request Accepted");
        fetch('/api/accept-friend-request', {
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({id: data.id})
        }).then((response) => response.json())
        .then((data) => {
            console.log(data);
            setStatus(true);
            setMessage("Friend Request Accepted");
        }).catch((error) => {
            setMessage("Something went wrong");
        })
     }
     const deleteRequest = () => {
   
    
        fetch('/api/delete-friend-request', {
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({id: data?.id})
        }).then((response) => response.json())
        .then((data) => {
            console.log(data);
            setStatus(true);
            setMessage("Friend Request Deleted");
        }).catch((error) => {
            setMessage("Something went wrong");
        })
     }


    if (type=="suggestion") {
      
   
  return (
        
          <div className="col-md-3 col-sm-4 col-6 pe-2 ps-2">
              <div className="card d-flex flex-column border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                <div className="card-body d-flex flex-column align-items-center w-100 ps-3 pe-3 pb-4 text-center">
                  <figure className="avatar-2 ms-auto me-auto mb-0 position-relative w65 z-index-1">
                    <Link to={`/profile/${data?.id}`} className="d-block">
                      <img src={data?.personal_details?.profile_picture || df} alt={data?.name || "avatar"} className="float-right p-0 bg-white rounded-circle w-100 shadow-xss" style={{aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center', cursor: 'pointer'}} />
                    </Link>
                  </figure>
                  <div className="clearfix" />
                  <h4 className="fw-700 font-xsss mt-3 mb-1">
                    <Link to={`/profile/${data?.id}`} className="text-grey-900 text-decoration-none d-block hover-opacity" style={{ cursor: 'pointer' }}>
                      {data?.name}
                    </Link>
                  </h4>
                  <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{data?.role}</p>
                  {}
                  {
                    status ? <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{message}</p> : 
                    <button className="p-2 lh-20 w100 bg-primary-gradiant me-2 text-white text-center font-xssss fw-600 ls-1 rounded-xl color-theme-red btn" onClick={sendRequest}>ADD FRIEND</button>
                  }
                </div>
              </div>
            </div> 
   
  )
   }
    if (type=="request") {
    
   
  return (
        
          <div className="col-md-3 col-sm-4 col-6 pe-2 ps-2">
              <div className="card  d-flex flex-column  border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                <div className="card-body  d-flex flex-column  w-100 ps-3 pe-3 pb-4 text-center">
                  <figure className="avatar-2 ms-auto me-auto mb-0 position-relative w65 z-index-1">
                     <Link to={`/profile/${data?.sender?.id}`}>
                    <img src={data?.sender?.personal_details?.profile_picture} alt="image" className="float-right p-0 bg-white rounded-circle w-100 shadow-xss" style={{aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center'}} />
                    </Link>
                    </figure>
                  <div className="clearfix" />
                  <h4 className="fw-700 font-xsss mt-3 mb-1">
                    <Link to={`/profile/${data?.sender?.id}`}>{data?.sender?.name}</Link>
                  </h4>
                  <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{data?.sender?.role}</p>
                  {}
                  {
                    status ? <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{message}</p> : 
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <button className="p-2 lh-20 me-2 mb-2 bg-primary-gradiant text-white text-center font-xsss fw-600 ls-1 rounded-xl color-theme-red btn" onClick={acceptRequest}>
                        ACCEPT
                      </button>
                      <button className="p-2 lh-20 me-2 mb-2 bg-danger text-white text-center font-xsss fw-600 ls-1 rounded-xl color-theme-red btn" onClick={deleteRequest}>
                        DELETE
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div> 
   
  )
   }
   if(type=="friend") {
 return (
     <div className="col-md-3 col-sm-4 col-6 pe-2 ps-2">
         <div className="card  d-flex flex-column  border-0 shadow-xss rounded-3 overflow-hidden mb-3">
             <div className="card-body  d-flex flex-column  w-100 ps-3 pe-3 pb-4 text-center">
                 <figure className="avatar-2 ms-auto me-auto mb-0 position-relative w65 z-index-1">
                    <Link to={`/profile/${data?.id}`}> <img
                     
                         src={data?.profile_picture}
                         alt="image"
                         className="float-right p-0 bg-white rounded-circle w-100 shadow-xss"
                         style={{aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center'}}
                     />
                     </Link>
                 </figure>
                 
                 <div className="clearfix" />
                 <Link to={`/profile/${data?.id}`}><h4 className="fw-700 font-xsss mt-3 mb-1">{data?.name}</h4></Link>
                 
                 <Link to={`/profile/${data?.id}`}><p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{data?.role}</p></Link>
                 
             </div>
         </div>
     </div>
 );
   }
   if (type=="request-mini") {
    console.log(data);
      return (
        <span>
            <div className="card-body d-flex pt-4 ps-4 pe-4 pb-0 border-top-xs bor-0">
              <figure className="avatar me-3"><img src={data?.sender?.personal_details?.profile_picture} alt="image" className="shadow-sm rounded-circle w45" style={{aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center'}} /></figure>
              <Link to={`/profile/${data?.sender?.id}`}><h4 className="fw-700 text-grey-900 font-xssss mt-1">{data?.sender?.name}</h4></Link>
              </div>
               {
                    status ? <p className="fw-500 font-xsssss text-center text-grey-500 mt-0 mb-3">{message}</p> : 
              <div className="card-body d-flex align-items-center pt-0 ps-4 pe-4 pb-4">
               <a onClick={acceptRequest} className="p-2 lh-20 w100 bg-primary-gradiant me-2 text-white text-center font-xssss fw-600 ls-1 rounded-xl color-theme-red">Confirm</a>
               <a onClick={deleteRequest} className="p-2 lh-20 w100 bg-grey text-grey-800 text-center font-xssss fw-600 ls-1 rounded-xl">Delete</a>
              </div>
              }

        </span>
      );
   }
   if(type=="profile-tag"){
    console.log("main card",data);
      if(data?.status=="pending"){
        if(data?.sender_id==user.id){
          return(
            <div className="d-flex align-items-center justify-content-center position-absolute-md right-0 top-0 me-2">
           <a href="#" className="w-100 bg-success p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 " >Connection Request Sent</a>
            </div>
          )
        } 
        return(
          <span>
            {  status ? <p className="fw-500 font-xsssss text-center text-grey-500 mt-0 mb-3">{message}</p> : 
          <div className="d-flex align-items-center justify-content-center position-absolute-md right-0 top-0 me-2">
              <a href="#" className="w-100 bg-success p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 " onClick={acceptRequest}>Accept</a>
              <a href="#" className="w-100 bg-danger p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 " onClick={deleteRequest}>Reject</a>
            </div>
      }
          </span>
        )
      }
      if(data?.status=="accepted"){
        return(
          <div className="d-flex align-items-center justify-content-center position-absolute-md right-0 top-0 me-2">
              <a href="#" className="w-100 bg-success p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 ">Connected</a>          
            </div>
        )
      }else{
      return (
        <span>

        { 
          status ? <a href="#" className="w-100 bg-success p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 " >Connection Request Sent</a> : 
          <div className="d-flex align-items-center justify-content-center position-absolute-md right-0 top-0 me-2">
              <a href="#" className="w-100 bg-success p-3 z-index-1 rounded-3 text-white font-xsssss text-uppercase fw-700 " onClick={sendRequest}>Add Friend</a>
          </div>
      }
      </span>
      )
    }
   }
}

export default FriendCardMain